"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftCardShape_1 = __importDefault(require("../LftCardShape"));
var S = __importStar(require("./LftCardBase.styles"));
var LftCardBase = function (_a) {
    var _b, _c;
    var bgColor = _a.bgColor, children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, height = _a.height, id = _a.id, padding = _a.padding, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, width = _a.width, lftClick = _a.lftClick;
    var cardBase = (0, react_1.createRef)();
    var _handleClick = function (e) {
        lftClick && lftClick(e);
    };
    var _handleKeydown = function (event) {
        var _a;
        switch (event.key) {
            case 'Enter':
            case 'Space':
                _handleClick(event);
                break;
            case 'Escape':
                (_a = cardBase.current) === null || _a === void 0 ? void 0 : _a.blur();
                break;
        }
    };
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf("localhost")) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "card_" + dataElement;
        }
    }
    return ((0, jsx_runtime_1.jsx)(S.Wrapper, __assign({ bgColor: bgColor, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-cardbase", "data-testid": dataTestId ? dataTestId : id && id, id: id, padding: padding, ref: cardBase, tabIndex: tabIndex, onClick: _handleClick, onKeyDown: _handleKeydown }, { children: (0, jsx_runtime_1.jsx)(LftCardShape_1.default, __assign({ bgColor: bgColor, height: height, width: width }, { children: children }), void 0) }), void 0));
};
exports.default = LftCardBase;
